module.exports = __webpack_public_path__ + "static/media/fitmatka-image.3017cd80.webp";